import React, { useState, useEffect } from 'react';
import './skills.css';
import ProgressBar from 'react-bootstrap/ProgressBar';
import CarouselSkills from './CarouselSkills/CarouselSkills';

const Skills = () => {
  // Estados para habilidades técnicas
  const [javascriptProgress, setJavascriptProgress] = useState(0);
  const [htmlCssProgress, setHtmlCssProgress] = useState(0);
  const [reactJsProgress, setReactJsProgress] = useState(0);
  const [nodeJsProgress, setNodeJsProgress] = useState(0);
  const [gitGithubProgress, setGitGithubProgress] = useState(0);

  // Estados para habilidades profesionales
  const [communicationProgress, setCommunicationProgress] = useState(0);
  const [teamWorkProgress, setTeamWorkProgress] = useState(0);
  const [creativityProgress, setCreativityProgress] = useState(0);
  const [problemSolvingProgress, setProblemSolvingProgress] = useState(0);
  const [projectManagementProgress, setProjectManagementProgress] = useState(0);

  // Función para incrementar progresivamente
  const incrementProgress = (setter, target) => {
    let progress = 0;
    const interval = setInterval(() => {
      progress += 2; // Incremento por tick
      setter(progress);
      if (progress >= target) {
        clearInterval(interval);
      }
    }, 150); // Reduce el tiempo de intervalo para mayor rapidez
  };
  
  useEffect(() => {
    // Técnicas
    incrementProgress(setJavascriptProgress, 72);
    incrementProgress(setHtmlCssProgress, 79);
    incrementProgress(setReactJsProgress, 73);
    incrementProgress(setNodeJsProgress, 63);
    incrementProgress(setGitGithubProgress, 80);
  
    // Profesionales
    incrementProgress(setCommunicationProgress, 95);
    incrementProgress(setTeamWorkProgress, 90);
    incrementProgress(setCreativityProgress, 82);
    incrementProgress(setProblemSolvingProgress, 86);
    incrementProgress(setProjectManagementProgress, 74);
  }, []);

  return (
    <section id='Skills'>
      <div className="skills" id="skills">
        <div className='contenido-seccion'>
          <h2>Skills</h2>
          <div className="fila">
            <div className="col">
              <h3>Technical Skills</h3>
              <div className="skill">
                <span className='skillText'>Javascript</span>
                <ProgressBar now={javascriptProgress} label={`${javascriptProgress}%`} />
              </div>
              <div className="skill">
                <span className='skillText'>HTML & CSS</span>
                <ProgressBar now={htmlCssProgress} label={`${htmlCssProgress}%`} />
              </div>
              <div className="skill">
                <span className='skillText'>React JS</span>
                <ProgressBar now={reactJsProgress} label={`${reactJsProgress}%`} />
              </div>
              <div className="skill">
                <span className='skillText'>Node JS</span>
                <ProgressBar now={nodeJsProgress} label={`${nodeJsProgress}%`} />
              </div>
              <div className="skill">
                <span className='skillText'>Git GitHub</span>
                <ProgressBar now={gitGithubProgress} label={`${gitGithubProgress}%`} />
              </div>
            </div>
            <div className="col">
                <h3>Professional Skills</h3>
                <div className="skill">
                    <span className='skillText'>Communication</span>
                    <ProgressBar now={communicationProgress} label={`${communicationProgress}%`} />
                </div>
                <div className="skill">
                    <span className='skillText'>Team Work</span>
                    <ProgressBar now={teamWorkProgress} label={`${teamWorkProgress}%`} />
                </div>
                <div className="skill">
                    <span className='skillText'>Creativity</span>
                    <ProgressBar now={creativityProgress} label={`${creativityProgress}%`} />
                </div>
                <div className="skill">
                    <span className='skillText'>Problem Solving</span>
                    <ProgressBar now={problemSolvingProgress} label={`${problemSolvingProgress}%`} />
                </div>
                <div className="skill">
                    <span className='skillText'>Project Management</span>
                    <ProgressBar now={projectManagementProgress} label={`${projectManagementProgress}%`} />
                </div>
            </div>
        </div>
    </div>
    </div>
    <div className='stackIcon'>
      <CarouselSkills />
    </div>
    </section>
  )
}

export default Skills;
